import { ListingCate } from '@/page-commons/listingBySlug'

import { citiesByLocale } from './locale-variables'

const availableServices = {
  additionalInfo: ['coolingSystem'],
  services: [
    'elevator',
    'basement',
    'parkingSpaces',
    'box',
    'garden',
    'conciergeService',
    'recreationRoom',
    'garret',
    'pool',
    'sharedPool',
    'tennisCourt',
    'fireplace',
    'disabledAccess',
    'wallCabinet',
    'fastInternet',
    'hydromassage',
    'tvSystem',
    'electricGate',
    'armoredDoor',
    'alarmSystem',
    'entranceVideoPhone',
  ],
}

const get = (listing: ListingCate): Array<string> => {
  const shouldIncludeService = (service: any) => {
    if (service?.counter && service.counter > 0) {
      return true
    } else if (service?.area && service.area > 0) {
      return true
    } else if (service?.areas && service.areas.length > 0) {
      return true
    } else if (service && service !== 'NONE') {
      return true
    }
    return false
  }

  const servicesUnderServices = availableServices.services.filter((item) => {
    return shouldIncludeService(listing.services[item])
  })

  const servicesUnderAdditionalInfo = availableServices.additionalInfo.filter((item) => {
    return shouldIncludeService(listing.additionalInfo[item])
  })

  return [...servicesUnderServices, ...servicesUnderAdditionalInfo]
}

/**
 * Validate urls containing city not matching its own locale
 * Eg.
 * /it/case-in-vendita/madrid
 * /es/casas-en-venta/milano
 */
const validateCity = (city: string, language: Locale): boolean => {
  // Guard agains spaces inside city name
  const formattedCity = city.replace(/\s+/g, '-')

  return citiesByLocale[language].includes(formattedCity.toLowerCase())
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  get,
  validateCity,
}
